var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"tableheader"},[_c('th',{staticClass:"fixed_header"},[_vm._v("Sr.No")]),_c('th',[_vm._v("No")]),_c('th',[_vm._v("Name")]),_c('th',[_vm._v("Actions")]),_c('personal-info-header'),_c('sputum-header'),_c('chest-xray-header'),_c('gene-xpert-header'),_c('tb-conclusion-header')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }